/*
 * City Optikhaus: einheitliche Brillengroesse in Produktkarten
 * Misst pro Bild den Rahmen (nicht den Weissraum) und skaliert/zentriert ihn,
 * sodass jede Fassung in der Karte mindestens ca. 86 % der Kartenbreite einnimmt (nur Vergroessern, nie Verkleinern).
 * Nur Bilder mit ruhigem einfarbigem Hintergrund werden angepasst; Fotos mit Kulisse/Model bleiben unveraendert.
 * Neue Produkte werden automatisch erfasst. Faellt etwas aus, bleibt das Originalbild unveraendert.
 * Hinweis an Agentur: Datei und das Script-Tag in layout/theme.liquid bei Theme-Updates uebernehmen.
 * 18.10.: Jede Karten-Slide schneidet ihr Bild jetzt selbst ab (overflow hidden). Vorher ragte das vergroesserte
 * Seitenbild der Nachbar-Slide in das erste Bild hinein und schnitt Brillen ab (v. a. mobil, 2 Spalten).
 */
(function () {
  'use strict';
  var TARGET = 0.86;       // Rahmenbreite im Verhaeltnis zur Kartenbreite
  var MIN_S = 1.03, MAX_S = 1.6;
  var SELECTOR = 'img.product-card__img';
  var cache = {};          // Basis-URL -> {x0,x1,y0,y1,ok}
  var pending = {};

  try {
    var cxst = document.createElement('style');
    cxst.textContent = 'product-card .product-card__slide{overflow:hidden!important}';
    document.head.appendChild(cxst);
  } catch (e) { }

  function baseUrl(src) { return (src || '').split('?')[0]; }

  function probeSrc(src) {
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', '240');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.toString();
    } catch (e) { return src; }
  }

  function measure(src, cb) {
    var key = baseUrl(src);
    if (cache[key]) { cb(cache[key]); return; }
    if (pending[key]) { pending[key].push(cb); return; }
    pending[key] = [cb];
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var res = { ok: false };
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data;
        // Hintergrundfarbe = Median der Randpixel; "Tinte" = deutlich andere Farbe
        var m = Math.max(2, Math.round(Math.min(w, h) * 0.03)), bs = [];
        for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
          if (yy < m || yy >= h - m || xx < m || xx >= w - m) bs.push((yy * w + xx) * 4);
        }
        function med(ch) { var a = bs.map(function (i) { return d[i + ch]; }).sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
        var bg = [med(0), med(1), med(2)], TH = 45;
        function isInk(i) { return d[i + 3] > 20 && (Math.abs(d[i] - bg[0]) > TH || Math.abs(d[i + 1] - bg[1]) > TH || Math.abs(d[i + 2] - bg[2]) > TH); }
        var bi = 0; for (var k = 0; k < bs.length; k++) if (isInk(bs[k])) bi++;
        if (bi / bs.length < 0.03) {
          var colCount = new Uint16Array(w), rowCount = new Uint16Array(h);
          for (var y = 0; y < h; y++) {
            for (var x = 0; x < w; x++) {
              if (isInk((y * w + x) * 4)) { colCount[x]++; rowCount[y]++; }
            }
          }
          var x0 = 0, x1 = w - 1, y0 = 0, y1 = h - 1;
          while (x0 < w && colCount[x0] < 3) x0++;
          while (x1 > x0 && colCount[x1] < 3) x1--;
          while (y0 < h && rowCount[y0] < 3) y0++;
          while (y1 > y0 && rowCount[y1] < 3) y1--;
          var fw = (x1 - x0 + 1) / w, fh = (y1 - y0 + 1) / h;
          if (fw > 0.08 && fw < 0.97 && fh > 0.03) {
            res = { ok: true, x0: x0 / w, x1: (x1 + 1) / w, y0: y0 / h, y1: (y1 + 1) / h, ar: w / h };
          }
        }
      } catch (e) { res = { ok: false }; }
      cache[key] = res;
      var q = pending[key] || []; delete pending[key];
      q.forEach(function (f) { f(res); });
    };
    im.onerror = function () {
      cache[key] = { ok: false };
      var q = pending[key] || []; delete pending[key];
      q.forEach(function (f) { f(cache[key]); });
    };
    im.src = probeSrc(src);
  }

  function apply(img, m) {
    if (!m || !m.ok) return;
    var rw = img.clientWidth, rh = img.clientHeight;
    if (!rw || !rh) return;
    // Darstellung mit object-fit: contain
    var boxAr = rw / rh, drawW, drawH;
    if (m.ar > boxAr) { drawW = rw; drawH = rw / m.ar; } else { drawH = rh; drawW = rh * m.ar; }
    var frameW = (m.x1 - m.x0) * drawW, frameH = (m.y1 - m.y0) * drawH;
    var s = (TARGET * rw) / frameW;
    s = Math.min(s, (0.5 * rw) / frameH);
    if (s < MIN_S) return;
    s = Math.min(MAX_S, s);
    var cx = ((m.x0 + m.x1) / 2 - 0.5) * drawW;
    var cy = ((m.y0 + m.y1) / 2 - 0.5) * drawH;
    img.style.transformOrigin = '50% 50%';
    img.style.transform = 'translate(' + (-cx * s).toFixed(1) + 'px,' + (-cy * s).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
    img.setAttribute('data-cx-fit', '1');
  }

  function process(img) {
    var src = img.currentSrc || img.src;
    if (!src || src.indexOf('data:') === 0) return;
    if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(src)) return;
    if (img.closest('.image-swatches, .product-card__image-swatches')) return;
    if (img.getAttribute('data-cx-src') === baseUrl(src) && img.getAttribute('data-cx-fit')) { measure(src, function (m) { apply(img, m); }); return; }
    img.setAttribute('data-cx-src', baseUrl(src));
    measure(src, function (m) { apply(img, m); });
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.complete && img.naturalWidth) process(img);
      else img.addEventListener('load', function () { process(img); }, { once: true });
    });
  }

  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { scan(); }, 120); }

  function init() {
    scan();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
